import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth-service';
import { environment } from '../../../environments/environment';
import { REQUEST_ACCESS_PATH, resolvePostLoginPath } from './auth-guard';

export const accessPendingGuard = async (): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.waitForAuthState();
  await authService.waitForClaims();

  const profile = authService.userProfile();
  const roles = profile?.roles || [];

  if (roles.length === 0) {
    const lacksToolAndAdminAccess = resolvePostLoginPath(authService) === REQUEST_ACCESS_PATH;
    return lacksToolAndAdminAccess ? router.createUrlTree([REQUEST_ACCESS_PATH]) : true;
  }

  const hasOtherRole = roles.some((role) => role !== 'construction_vendor');
  const isEnabled =
    environment.constructionVendorEnabled !== false && !profile?.constructionVendorDisabled;

  if (hasOtherRole) {
    return true;
  }

  if (roles.includes('construction_vendor') && isEnabled) {
    return true;
  }

  return router.createUrlTree(['/access-pending']);
};
